module.exports = __webpack_public_path__ + "dist/img/manual.e19cc350.svg";